<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records order-dna-section">
            <div class="row h-100">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-5">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-md-10 text-center Order-kit">
                                        <div class="row">
                                            <div class="col-md-6 text-left">
                                                <h2>Comprehensive Full Body Checkup</h2>
                                                <div class="d-flex justify-content-between align-items-center mb-2 Includes-labes mt-3">
                                                    <h4 class="mb-o">Includes 91 Tests</h4>
                                                    <figure class="mb-0 gini-labs mt-0"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                </div>
                                                <h2>Test Information</h2>
                                                <div class="must-know p-3 border-radius-8">
                                                    <h2>You Must Know</h2>
                                                    <ul class="mb-0 mt-3">
                                                        <li class="d-flex justify-content-start"><i class="icon icon-Info"></i>Sample Type: Blood</li>
                                                        <li class="d-flex justify-content-start"><i class="icon icon-Food"></i>Fasting Required: Yes</li>
                                                        <li class="d-flex justify-content-start"><i class="icon icon-Info"></i>Special Instruction: Do not eat or drink anything other than water for 8-12 hours before the test.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-6 text-left">
                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                    <h3>Address Details</h3>
                                                    <a href="#" class="Change-address">Change Address</a>
                                                </div>
                                                <p>Address details will help us provide you the best selection of labs near your vicinity</p>
                                                <div class="Address d-flex justify-content-between border-top border-bottom py-3">
                                                    <p>D179 Phase 8B Mohali, Finvasia Center, Mohali (Punjab) 160088</p>
                                                    <a href="#" class="edit-icon"><i class="icon icon-pencil"></i></a>
                                                </div>
                                                <form class="radio-box mt-4">
                                                    <div class="form-group m-0">
                                                        <input type="checkbox" id="html" />
                                                        <label class="mb-0" for="html">Check if this is for someone else.</label>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-end mt-5">
                                            <router-link class="btn btn-blue book-test" to="/cart-test">Book Test</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "Order-dnaKit",
        data() {
            return {};
        },
        created(){
           this.pageName('Order DNA Kit')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/dna/order-dna-kit.vue